/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import MUIFormControlLabel from '@material-ui/core/FormControlLabel';
import styled from 'styled-components';
import { Spacings } from '@styles/index';

const StyledCheckbox = styled(Checkbox)`
  &.MuiButtonBase-root {
    padding: 0px;
    padding-right: ${Spacings.SPACING_2B};
    background: none;
    color: ${({ theme, color, checked }) =>
      (checked && color) || theme.colors.fontGrey};
    .MuiIconButton-label {
      input {
        top: 0;
        left: 0;
        width: 100%;
        cursor: inherit;
        height: 100%;
        margin: 0;
        opacity: 0;
        padding: 0;
        z-index: 1;
        position: absolute;
      }
    }
  }
`;

const FormControlLabel = styled(MUIFormControlLabel)`
  color: ${({ theme, color }) => color || theme.colors.fontGrey};
  &.MuiFormControlLabel-root {
    margin-left: 0px;
  }
`;

const MUICheckbox = (props) => {
  const { checked, className, label, color, ...data } = props;

  const checkbox = (
    <StyledCheckbox
      disableFocusRipple
      disableTouchRipple
      disableRipple
      size="small"
      color={color || 'default'}
      checked={checked}
      {...data}
    />
  );

  if (label)
    return (
      <FormControlLabel
        control={checkbox}
        label={label}
        color={color}
        className={className}
      />
    );

  return checkbox;
};

export default MUICheckbox;

MUICheckbox.propTypes = {
  label: PropTypes.string
};

MUICheckbox.defaultProps = {
  label: ''
};
